import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumns12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextColumns12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5M1.5 4a.5.5 0 0 0 0 1H3a.5.5 0 0 0 0-1zM1 8.5a.5.5 0 0 1 .5-.5H3a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5m6.5-6A.5.5 0 0 1 8 2h2.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5m0 4A.5.5 0 0 1 8 6h2.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5M8 4a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1zm-.5 4.5A.5.5 0 0 1 8 8h1.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumns12);
